import en from 'rc-picker/lib/locale/en_US';
import es from 'rc-picker/lib/locale/es_ES';
import fr from 'rc-picker/lib/locale/fr_FR';
import vi from 'rc-picker/lib/locale/vi_VN';
import ko from 'rc-picker/lib/locale/ko_KR';
import zh from 'rc-picker/lib/locale/zh_CN';
import useContentfulLocale from '../useContentfulLocale';

const contentfulToRcPickerMapping = {
  es,
  fr,
  vi,
  ko,
  'zh-Hans': zh,
  'zh-Hant': zh,
};

const useDateMonthPickerLocale = () => {
  const ctfLocaleFilter = useContentfulLocale();
  const locale = contentfulToRcPickerMapping[ctfLocaleFilter.locale] || en;

  return locale;
};

export default useDateMonthPickerLocale;
